module.exports = __webpack_public_path__ + "img/Impact characterisation - Cumulative.f3dc86ab.svg";